var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaceScanning = function SvgFaceScanning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 239 283"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E7EB",
    strokeWidth: 2,
    d: "M174.536 122.754c3.443-5.452 12.338.861 13.486 10.33 2.009 10.043-4.591 37.878-18.078 44.191M63.841 122.764c-3.443-5.452-12.339.861-13.487 10.33-2.008 10.043 4.592 37.878 18.078 44.19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E5E7EB",
    strokeWidth: 2,
    d: "M118.007 47c-41.78 0-55.955 35.486-57.677 53.372-1.105 11.478-1.722 39.312.86 45.625 3.157 9.183 7.303 46.486 7.749 49.068 1.682 9.757 21.52 27.547 22.382 28.121.86.574 10.981 10.653 15.208 11.765 5.452 1.435 18.364 2.009 24.39 0 6.6-1.148 13.2-9.756 16.356-12.339 2.009-2.008 20.76-17.79 22.669-27.547 2.639-13.486 4.978-39.885 7.174-49.068 3.156-13.199 2.296-35.008 1.148-47.346C175.396 81.434 162.197 47 118.007 47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeDasharray: "2 2",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m93.5 65 11 41.5M93.5 65H145m-51.5 0-27 15m38 26.5H134m-29.5 0-11 13.5m11-13.5L66.5 80m67.5 26.5L145 65m-11 41.5 11 13.5m-11-13.5L173 80m-28-15 28 15m-79.5 40 25.5 23.5M93.5 120H74m45 23.5 26-23.5m-26 23.5 25 14.5m-25-14.5L95.5 158m23.5-14.5 9.5 27.5m-9.5-27.5-9.5 27.5m35.5-51h19.5m8.5-40-8.5 40m0 0 13.5 23-34 15M66.5 80l7.5 40m0 0-13.5 23 35 15m48.5 0-15.5 13m15.5-13 .5 44m-.5-44 24.5 39-24 5m-16-31h-19m19 0-9.5 8.5-9.5-8.5m19 0 16 31m-35-31-14-13m14 13-16 31m2-44-2 44m2-44-26 39 24 5m51 0L119 218m25.5-16 1.5 22-27-6m0 0-25.5-16m25.5 16-26.5 6 1-22"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144.693,
    cy: 201.952,
    r: 1.722,
    fill: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.867,
    cy: 218.021,
    r: 1.722,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.616,
    cy: 201.952,
    r: 1.722,
    fill: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.722,
    cy: 196.722,
    r: 1.722,
    fill: "#000"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.722,
    cy: 142.722,
    r: 1.722,
    fill: "#000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.722,
    cy: 142.722,
    r: 1.722,
    fill: "#000"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.722,
    cy: 196.722,
    r: 1.722,
    fill: "#000"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.722,
    cy: 223.722,
    r: 1.722,
    fill: "#000"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.722,
    cy: 223.722,
    r: 1.722,
    fill: "#000"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.867,
    cy: 179.57,
    r: 1.722,
    fill: "#000"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.624,
    cy: 170.961,
    r: 1.722,
    fill: "#000"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.722,
    cy: 157.722,
    r: 1.722,
    fill: "#000"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.338,
    cy: 157.762,
    r: 1.722,
    fill: "#000"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.685,
    cy: 170.961,
    r: 1.722,
    fill: "#000"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.867,
    cy: 143.414,
    r: 1.722,
    fill: "#000"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.52,
    cy: 106.685,
    r: 1.722,
    fill: "#000"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.616,
    cy: 119.885,
    r: 1.722,
    fill: "#000"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.693,
    cy: 119.885,
    r: 1.722,
    fill: "#000"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.205,
    cy: 119.885,
    r: 1.722,
    fill: "#000"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.722,
    cy: 79.722,
    r: 1.722,
    fill: "#000"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.722,
    cy: 79.722,
    r: 1.722,
    fill: "#000"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.789,
    cy: 106.685,
    r: 1.722,
    fill: "#000"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.103,
    cy: 119.885,
    r: 1.722,
    fill: "#000"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.616,
    cy: 64.79,
    r: 1.722,
    fill: "#000"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.693,
    cy: 64.79,
    r: 1.722,
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E5E7EB",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M200 1h17c6.523 0 9.785 0 12.358 1.066a14 14 0 0 1 7.576 7.576C238 12.215 238 15.477 238 22v13M38 1H22c-6.523 0-9.785 0-12.358 1.066a14 14 0 0 0-7.576 7.576C1 12.215 1 15.477 1 22v14m199 246h17c6.523 0 9.785 0 12.358-1.066a14 14 0 0 0 7.576-7.576C238 270.785 238 267.523 238 261v-14M38 282H22c-6.523 0-9.785 0-12.358-1.066a14 14 0 0 1-7.576-7.576C1 270.785 1 267.523 1 261v-14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#253A60",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M1.75 161.25h235.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#face-scanning_svg__a)",
    d: "M1 162h237v120H1z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "face-scanning_svg__a",
    x1: 120,
    x2: 120,
    y1: 84.282,
    y2: 282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4FF",
    stopOpacity: 0.45
  })))));
};
export default SvgFaceScanning;